const situations = [
    {id:'started', 'label':'Iniciado'},
    {id:'approved', 'label':'Agendado'},
    {id:'missed', 'label':'Não realizado'},
    {id:'canceled', 'label':'Cancelado'},
    {id:'done', 'label':'Realizado'}
];
export default situations;
